"use strict";
exports.__esModule = true;
exports.SOFT_CREDIT_CHECK_LEARN_MORE_MODAL_CONTENT = void 0;
exports.SOFT_CREDIT_CHECK_LEARN_MORE_MODAL_CONTENT = {
    TITLE: 'More about credit checks',
    CTA: 'Done',
    MAIN_TEXT_1: 'Flex needs to access your credit report in order to present an offer for a Flex credit line. Your credit score and other information will be used to determine how much credit you may be offered. Your Flex credit line will determine how you’ll be able to split up your rent payments.',
    MAIN_TEXT_2: 'Because this is a ’soft’ credit check, your credit score will not be impacted.'
};
